import { observer } from 'mobx-react';
import React from 'react';
import {
	IButtonStyles,
	Stack,
	getTheme,
	Text,
	IconButton,
} from '@fluentui/react';
import { FilterOptionsState } from '../../state/FilterOptionsState';
import { FiltersState } from '../../state/FiltersState';
import FilterOptions from '../controls/FilterOptions';
import { IUserConfigPackage } from '../../API';

export interface IFilterDisplayWidgetProps {
	filterField: FilterOptionsState;
	filters: FiltersState;
	userConfig: IUserConfigPackage;
}

class FilterDisplayWidget extends React.Component<IFilterDisplayWidgetProps> {
	render() {
		if (this.props.filterField.selectedFilterOptions.length === 0) {
			return <></>;
		}

		return (
			<Stack
				tokens={{ childrenGap: 5 }}
				horizontal
				verticalAlign="center"
				styles={{ root: { backgroundColor: 'white' } }}
				style={{ padding: 5 }}
			>
				<Text>{this.props.filterField.columnInfo.displayName}: </Text>
				{this.getSelectedFilterContent()}
			</Stack>
		);
	}

	private getSelectedFilterContent(): React.ReactNode {
		const theme = getTheme();
		const dismissIconStyles: Partial<IButtonStyles> = {
			root: {
				paddingTop: 2,
				color: theme.palette.neutralPrimary,
				verticalAlign: 'center',
				margin: 0,
			},
			rootHovered: {
				color: theme.palette.neutralDark,
			},
		};

		return this.props.filterField.selectedFilterOptions.map((filter) => {
			return (
				<Stack
					horizontal
					verticalAlign="center"
					styles={{
						root: {
							backgroundColor: theme.palette.neutralLighter,
							borderRadius: 16,
							padding: '0px 8px',
							maxHeight: 30,
						},
					}}
				>
					{FilterOptions.renderLabel(
						this.props.userConfig,
						filter,
						this.props.filterField.columnInfo,
					)}
					<IconButton
						styles={dismissIconStyles}
						iconProps={{ iconName: 'Cancel', style: { fontSize: '12px' } }}
						ariaLabel="Close"
						onClick={() => {
							this.props.filterField.removeFilterOption(filter);
							this.props.filters.removeFilter(
								this.props.filterField.columnInfo.id,
								filter.internal_value,
							);
							this.props.filters.applyFilters();
						}}
					/>
				</Stack>
			);
		});
	}
}

export default observer(FilterDisplayWidget);
